export enum AfterApprovalStatus {
  Approved = 'Approved',
  Added = 'Added',
  Modified = 'Modified',
  Removed = 'Removed',
}
